import React, { useState } from "react"
import {
  CButton,
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CFormLabel,
  CRow,
  CCol,
  CCardBody
} from "@coreui/react"

import Carder from "../../components/shared/Carder"
import CustomDatePickingFormat from "../../components/shared/CustomDatePickingFormat"
import Graytextarea from '../../components/Graytextarea.jsx'
import PsychiatryNotesCRUD from '../../services/general/PsychiatryNotesAPI.api'
import { useEffect } from "react"
const PatientPsychiatryNote = ({ patientID,noteStructureRef }) => {

  const [modalVisible, setModalVisible] = useState(false)
  const [deleteVisibleId, setDeleteVisibleId] = useState(null)
  const [notesList, setNotesList] = useState([])
  const [editId, setEditId] = useState(null)
  const [noteData, setNoteData] = useState({
    date: "",
    notes: ""
  })
useEffect(() => {
  if (patientID) {
    getPatientPsychiatryNotes()
  }
}, [patientID])



const syncToNoteStructure = (list) => {
  if (!noteStructureRef?.current) return

  const ids = list.map((item) => item.id)

  noteStructureRef.current = {
    ...noteStructureRef.current,
    metadata: {
      ...noteStructureRef.current.metadata,
      psychiatryNoteId: ids,  
    },
  }
}

const handleSave = async () => {
  if (editId !== null) {
    await PsychiatryNotesCRUD(
      'UPDATE',
      patientID.toString(),
      noteData.notes,
      noteData.date,
      editId
    )

    setEditId(null)
  } else {
    const res = await PsychiatryNotesCRUD(
      "INSERT",
      patientID.toString(),
      noteData.notes,
      noteData.date,
      ""
    )

    const latestId = JSON.parse(res?.d)?.Data?.Id
  }

  setNoteData({ date: "", notes: "" })
  setModalVisible(false)

  const updatedList = await getPatientPsychiatryNotes()
  syncToNoteStructure(updatedList)   // ✅ ALWAYS SYNC HERE
}

  const handleEdit = (note) => {
    setNoteData({
      date: note.date,
      notes: note.notes
    })

    setEditId(note.id)
    setModalVisible(true)
  }

const handleDelete = async () => {
  await PsychiatryNotesCRUD(
    'DELETE',
    patientID.toString(),
    null,
    null,
    deleteVisibleId
  )

  setDeleteVisibleId(null)

  const updatedList = await getPatientPsychiatryNotes()
  syncToNoteStructure(updatedList)   // ✅ REQUIRED
}
const getPatientPsychiatryNotes = async () => {
  const res = await PsychiatryNotesCRUD(
    "GET",
    patientID.toString(),
    "",
    "",
    ""
  )

  const data = JSON.parse(res?.d || "{}")
  const list = data?.Data || []

  const formatted = list.map((item) => ({
    id: item.Id,
    date: item.Date,
    notes: item.PsychiatryNotes || item.Notes || "",
  }))

  const sorted = [...formatted].sort((a, b) => b.id - a.id)

  setNotesList(sorted)

  return sorted   // ✅ IMPORTANT
}

  return (
    <>

      <CButton
        color="primary"
        variant="outline"
        onClick={() => setModalVisible(true)}
        style={{ marginTop: '10px' }}
        className="patient-page-action-btn"
      >
       + Add Psychiatry Note
      </CButton>


      {/* Saved Notes */}

      {notesList.length > 0 ? (
        notesList.map((note) => (
          <Carder
            key={note.id}
            editFunc={() => handleEdit(note)}
            deleteFunc={() => setDeleteVisibleId(note.id)}
            className="mt-3">

            <CCardBody>
                      
                <p>Date : {new Date(note.date).toLocaleDateString('en-US', {
                                                month: '2-digit',
                                                day: '2-digit',
                                                year: 'numeric'
                                            })}</p>
              <div
                className="mt-2"
                style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}
              >
                {note.notes}
              </div>

            </CCardBody>
          </Carder>

        ))
      ) : (
        <div className="text-center text-muted mt-3">
          No Psychiatry Notes Available
        </div>
      )}


      {/* Add / Edit Modal */}

      <CModal
        size="lg"
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
      >

        <CModalHeader>
          <CModalTitle>
            {editId !== null ? "Edit Psychiatry Note" : "Add Psychiatry Note"}
          </CModalTitle>
        </CModalHeader>

        <CModalBody>

          <CRow className="mb-3">
            <CCol md="6">

              <CFormLabel>Date</CFormLabel>

              <CustomDatePickingFormat
                value={noteData.date}
                onChange={(e) =>
                  setNoteData((p) => ({
                    ...p,
                    date: e
                  }))
                }
                format="mm-dd-yyyy"
              />

            </CCol>
          </CRow>

          <CFormLabel>Notes</CFormLabel>

          <Graytextarea
  rows={4}
  height={"200px"}
  value={noteData?.notes}
  onChange={(e) =>
    setNoteData((p) => ({
      ...p,
      notes: e.target.value,
    }))
  }
/>

        </CModalBody>

        <CModalFooter>

          <CButton
            color="secondary"
            variant="outline"
            onClick={() => setModalVisible(false)}
          >
            Cancel
          </CButton>

          <CButton 
            color="primary" 
            onClick={handleSave}
            style={{
              backgroundColor: 'var(--ui-color-primary, #2b7cd3)',
              borderColor: 'var(--ui-color-primary, #2b7cd3)',
            }}
          >
            {editId !== null ? "Update Note" : "Save Note"}
          </CButton>

        </CModalFooter>

      </CModal>


      {/* Delete Modal */}

      <CModal visible={deleteVisibleId !== null}>

        <CModalHeader>
          <CModalTitle>Warning</CModalTitle>
        </CModalHeader>

        <CModalBody>
          Are you sure you want to delete?
        </CModalBody>

        <CModalFooter>

          <CButton
         className="text-white"
                  color="secondary"
            onClick={() => setDeleteVisibleId(null)}
          >
            Close
          </CButton>

          <CButton
            color="danger"
            className="text-white"
            onClick={handleDelete}
          >
            Delete
          </CButton>
        </CModalFooter>

      </CModal>

    </>
  )
}

export default PatientPsychiatryNote
